import {formatTimestamp} from '@wandb/weave/components/Timestamp';
import React from 'react';
import {type FormatOptionLabelMeta} from 'react-select';

import {ColorIndicator} from '../LinkRun';
import {type RunOption} from './hooks';
import * as S from './JobDrawerConfigImporter.styles';

interface RunOptionLabelProps {
  props: RunOption;
  context: FormatOptionLabelMeta<RunOption>;
  customRunColors?: Record<string, string>;
}

export const RunOptionLabel = ({
  props,
  context,
  customRunColors,
}: RunOptionLabelProps) => {
  const {run} = props;

  if (context.context === 'value') {
    return (
      <S.OptionRow>
        <S.OptionColorIndicator>
          <ColorIndicator
            name={run.name}
            defaultColor={run.defaultColor}
            customRunColors={customRunColors ?? {}}
          />
        </S.OptionColorIndicator>
        <S.OptionaLabelText>{run.displayName}</S.OptionaLabelText>
      </S.OptionRow>
    );
  }

  return (
    <S.OptionRow>
      <S.OptionColorIndicator>
        <ColorIndicator
          name={run.name}
          defaultColor={run.defaultColor}
          customRunColors={customRunColors ?? {}}
        />
      </S.OptionColorIndicator>
      <S.OptionLabelTextContainer>
        <S.OptionaLabelText>{run.displayName}</S.OptionaLabelText>
        <S.OptionLabelSubtitleText>
          {formatTimestamp(run.createdAt).short}
        </S.OptionLabelSubtitleText>
      </S.OptionLabelTextContainer>
    </S.OptionRow>
  );
};
